import { RouteComponentProps, Router } from '@reach/router';
import { AccessPointsDetails } from './Details';
import { AccessPointsList } from './List';
import { AccessPointsParcels } from './Parcels';
import { AccessPointsActivityPool } from './ActivityPool';
import { ApiMonitor } from './ApiMonitor';
import { AccessPointMigration } from './Migration';

interface UPSProps extends RouteComponentProps {}

export const UPSPage: React.FC<UPSProps> = () => {
  return (
    <Router>
      <AccessPointsList path="/access-points/list" />
      <AccessPointsParcels path="/access-points/parcels" />
      <AccessPointsActivityPool path="/access-points/activity-pool" />
      <AccessPointMigration path="/access-points/migration" />
      <AccessPointsDetails path="/access-points/:id" />
      <ApiMonitor path="/api-monitor" />
    </Router>
  );
};
